import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthComponent } from './auth/auth.component';
import { AdRedirectComponent } from './auth/ad-redirect/ad-redirect.component';
import { loginGuard } from './core/guards/login.guard';

const routes: Routes = [
    { path: '', redirectTo: '/login', pathMatch: 'full' },
    { path: 'login', component: AuthComponent, canActivate: [loginGuard] },
    { path: 'ad-redirect', component: AdRedirectComponent },
    {
        path: 'backoffice',
        loadChildren: () => import('./maintainer/maintainer.module').then((m) => m.MaintainerModule),
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
